import { useMarketConfig } from '~/app/market-config';

/**
 * Returns the `vatConfig` from the current market config, which is used to decide,
 * whether prices should be displayed incl./excl. VAT.
 *
 * @example
 * const { formatCurrency } = useCurrencyFormatter();
 * const vatConfig = useVATConfig();
 * const featurePrice = formatCurrency(123.45, vatConfig.feature);
 * // => '123,45 € (exkl. MwSt.)'
 * const totalPrice = formatCurrency(123.45, vatConfig.totalPrice);
 * // => '123,45 € (inkl. MwSt.)'
 */
export function useVATConfig() {
	const { config } = useMarketConfig();
	return config.uiPreferences.prices.vatConfig;
}
